export class StepState {
    step: string;
    visited: boolean;
    valid: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/step-state.model.ts